import { render, staticRenderFns } from "./symptom_manifestation.vue?vue&type=template&id=3e2b5c6d&scoped=true"
import script from "./symptom_manifestation.vue?vue&type=script&lang=js"
export * from "./symptom_manifestation.vue?vue&type=script&lang=js"
import style0 from "./symptom_manifestation.vue?vue&type=style&index=0&id=3e2b5c6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2b5c6d",
  null
  
)

export default component.exports